import { render } from "./Speaker0.vue?vue&type=template&id=0378d802"
import script from "./Speaker0.vue?vue&type=script&lang=js"
export * from "./Speaker0.vue?vue&type=script&lang=js"
script.render = render

export default script